import cx from 'classnames'
import { type ReactNode } from 'react'

interface CollectionQuickFilterOptionProps {
  isActive: boolean
  onClick: () => void
  children: ReactNode
}

const CollectionQuickFilterOption = ({
  isActive,
  onClick,
  children,
}: CollectionQuickFilterOptionProps) => {
  return (
    <button
      onClick={onClick}
      className={cx('text-xs uppercase leading-none whitespace-nowrap', {
        'text-gray-dark': !isActive,
      })}
    >
      {children}
    </button>
  )
}

export default CollectionQuickFilterOption
